<p-dialog header="Envelope" [(visible)]="showEnvelopeDialog" (onHide)="closeFrame()" [style]="{width: '100vw', height: '100vw'}"
          class="activity-popup" [modal]="true">
  <ng-container *ngIf="iframeUrl">
    <iframe [src]="iframeUrl"
            style="width: 100%; height: 100%; border: none;"
            frameborder="0">
    </iframe>
  </ng-container>
</p-dialog>
